<template>
  <section :class="mainCssClass" v-bind:id="id">
    <div class="content" v-bind:class="contentClass">

      <h2 class="section__title" @click="emitSectionClicked">
        {{ title }}
        <img src="/images/icons_svg/checkbox-icon.svg" class="section__title--icon-check" v-if="preview != true"></img>
      </h2>
      <div class="booking-content-inner" v-if="preview != true">
        <slot></slot>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ['id', 'contentClass', 'title', 'collapsed', 'preview'],
  computed: {
    mainCssClass(){
      let css = ['booking-section']
      if (this.preview == true){
        css.push('section-preview')
      }else {
        if (this.collapsed == true){
          css.push('collapsed')
        }else {
          css.push('not-collapsed')
        }
      }
      return css.join(" ")
    }
  },
  mounted(){
    // adding scroll watch for header section
    //const header = $(`#${this.id} .section__title`)
    //const headerX = header.offset().top
    //$(window).scroll(()=> {
    //  if ($(window).scrollTop() > headerX){
    //    console.log($(window).scrollTop(), this.id)
    //    header.addClass('sticky')
    //  }else{
    //    header.removeClass('sticky')
    //  }
    //})
  },
  methods: {
    emitSectionClicked(){
      if (this.preview != true){
        this.$emit('section-clicked')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  #booking.content { width: 100%}
</style>